import { render } from "./UserSecurity.vue?vue&type=template&id=64e769c8"
import script from "./UserSecurity.vue?vue&type=script&lang=js"
export * from "./UserSecurity.vue?vue&type=script&lang=js"
script.render = render

export default script